import { render, staticRenderFns } from "./hvd-qrcode.vue?vue&type=template&id=2ba14ca4&lang=pug&"
import script from "./hvd-qrcode.vue?vue&type=script&lang=js&"
export * from "./hvd-qrcode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports